import * as nookies from 'nookies';

export const getCookies = ctx => {
  return nookies.parseCookies(ctx);
};

export const getCookie = (ctx, name) => {
  return getCookies(ctx)[name];
};

export const setCookie = (ctx, name, value, options) => {
  nookies.setCookie(ctx, name, value, options);
};

export const destroyCookie = (ctx, name, options) => {
  nookies.destroyCookie(ctx, name, options);
};
